const EmailSettings = () => {
    return <h3>EmailSettings</h3>
}

export default EmailSettings;